import React from "react";
import './Header.css'

export const Header = ({name}) => {
  return (
  <div className="heading">
    {`${name}`}
  </div>
  )
};
